import { Navigate, useLocation, type RouteObject } from 'react-router';

/** Client redirect retains fragments as well as query parameters in existing bookmarks. */
function LegacyAdminRedirect() {
  const location = useLocation();
  return (
    <Navigate
      replace
      to={
        location.pathname.replace(/^\/admin(?=\/|$)/, '/settings/system') +
        location.search +
        location.hash
      }
    />
  );
}

export const legacyAdminRoute: RouteObject = { path: 'admin/*', Component: LegacyAdminRedirect };
